// SortSelect.tsx
import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { DumpListSort } from '../../types';

export interface SortSelectProps {
  defaultValue: DumpListSort;
  onChange: (value: DumpListSort) => void;
}

const { Option } = Select;

const SortSelect: FC<SortSelectProps> = ({ defaultValue, onChange }) => {
  const { t } = useTranslation();
  return (
    <Select
      style={{ width: 220, float: 'right', marginBottom: 10 }}
      bordered={false}
      defaultValue={defaultValue}
      onChange={(v) => onChange(v as DumpListSort)}
    >
      <Option value={DumpListSort.DATE_DESC}>{t('sorting.DATE_DESC')}</Option>
      <Option value={DumpListSort.DATE_ASC}>{t('sorting.DATE_ASC')}</Option>
      <Option value={DumpListSort.NAME_ASC}>{t('sorting.NAME_ASC')}</Option>
      <Option value={DumpListSort.NAME_DESC}>{t('sorting.NAME_DESC')}</Option>
    </Select>
  );
};
export { SortSelect };
